app.factory('referralService', ['$q', '$rootScope', 'baseService', 'objectHelper', 'config', 'authInterceptor', '$sce', 'applicationModel',
    function($q, $rootScope, baseService, objectHelper, config, authInterceptor, $sce) {

        function ReferralService() {

            this.save = function(referral) {
                return baseService.post(config.API_URL + '/referrals', referral).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, ReferralVO);
                        data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.update = function(referral) {
                return baseService.post(config.API_URL + '/referrals/' + referral.id, referral).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, ReferralVO);
                        data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.delete = function(referral) {
                return baseService.delete(config.API_URL + '/referrals/' + referral.id).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.downloadPDF = function(referralId) {
                var options = {
                    headers: {
                        'Content-type': 'application/json',
                        'X-AUTH-TOKEN': authInterceptor.token
                    },
                    responseType: 'arraybuffer'
                };

                return baseService.get(config.API_URL + '/referrals/' + referralId + "/pdf/download", options).then(
                    function(successResponse) {
                        var file = new Blob([successResponse], { type: 'application/pdf' });
                        var fileURL = URL.createObjectURL(file);
                        var link = $sce.trustAsResourceUrl(fileURL);

                        return link;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.sendEReferral = function(referral) {
                $rootScope.$broadcast(Event.LOADING, true);
                return baseService.post(config.API_URL + '/referrals/p1', referral).then(
                    function(successResponse) {
                        $rootScope.$broadcast(Event.LOADING, false);
                        var data = objectHelper.translateObject(successResponse, EReferralResponseVO);

                        return data;
                    },
                    function(errorResponse) {
                        $rootScope.$broadcast(Event.LOADING, false);
                        return $q.reject(errorResponse);
                    }
                );
            };
        }

        return new ReferralService();
    }
]);
